import { useOpenPositionStoreBase } from './openPosition.store';
import { OpenPositionStore } from './openPosition.types';

// ======= Store Selectors - To be used with functions outside react (NON-REACTIVE) =======
// #region Store Selectors
const openPositionStoreSelector = () => useOpenPositionStoreBase.getState().state;

const openPositionMarkDataSelectorByProductId = (id: number) => {
  return openPositionStoreSelector().openPositionMarkData.get(id);
};

const openPositionMarkPriceSelectorByProductId = (id: number) => {
  return openPositionMarkDataSelectorByProductId(id)?.mark_price;
};

const openPositionBestAskSelectorByProductId = (id: number) => {
  return openPositionMarkDataSelectorByProductId(id)?.best_ask;
};

const openPositionBestBidSelectorByProductId = (id: number) => {
  return openPositionMarkDataSelectorByProductId(id)?.best_bid;
};
// #endregion Store Selectors

// ========  Reactive Data Selectors - To be used with components (Reactive Data) ========
// Usage -> const markPriceValue = useOpenPositionStoreBase(selectOpenPositionMarkPriceById(id));
// #region Reactive Data Selectors
const selectOpenPositionBestAsk = (store: OpenPositionStore) =>
  store.state.openPositionBestAsk;

const selectOpenPositionBestBid = (store: OpenPositionStore) =>
  store.state.openPositionBestBid;

const selectAllOpenPositionMarkData = (store: OpenPositionStore) =>
  store.state.openPositionMarkData;

const selectOpenPositionMarkDataById = (id: number) => (store: OpenPositionStore) =>
  store.state.openPositionMarkData.get(id);

const selectOpenPositionMarkPriceById = (id: number) => (store: OpenPositionStore) =>
  store.state.openPositionMarkData.get(id)?.mark_price;

const selectOpenPositionBestAskById = (id: number) => (store: OpenPositionStore) =>
  store.state.openPositionMarkData.get(id)?.best_ask;

const selectOpenPositionBestBidById = (id: number) => (store: OpenPositionStore) =>
  store.state.openPositionMarkData.get(id)?.best_bid;

// #endregion Reactive Data Selectors

export {
  // #region Store Selectors (NON-REACTIVE)
  openPositionStoreSelector,
  openPositionMarkDataSelectorByProductId,
  openPositionMarkPriceSelectorByProductId,
  openPositionBestAskSelectorByProductId,
  openPositionBestBidSelectorByProductId,
  // #endregion

  // #region Reactive Selectors (use with useOpenPositionStoreBase)
  selectOpenPositionBestAsk,
  selectOpenPositionBestBid,
  selectAllOpenPositionMarkData,
  selectOpenPositionMarkDataById,
  selectOpenPositionMarkPriceById,
  selectOpenPositionBestAskById,
  selectOpenPositionBestBidById,
  // #endregion
};
